/**
 * Calcula % de progresso de upload (XHR / DirectUpload).
 * Serve para exibir barra enquanto arquivo pesado sobe — evita sensação de “travou”.
 * Usado por fileUploadMixin e AttachmentsPreview.
 */
export function uploadProgressPercent(loaded, total) {
  const t = Number(total);
  const l = Number(loaded);
  if (!Number.isFinite(t) || t <= 0 || !Number.isFinite(l) || l < 0) {
    return 0;
  }
  return Math.min(100, Math.max(0, Math.round((l / t) * 100)));
}
